import React from 'react'
import { useIntl } from 'react-intl'

// utils
import { formatAccessibleDuration, toHoursAndMinutes } from '../../utils/helper'

// components
import VisuallyHidden from '../../atoms/VisuallyHidden/VisuallyHidden'

type Props = {
	from?: number
	to?: number
}

const RenderDuration = ({ from, to }: Props) => {
	const { formatMessage } = useIntl()
	const fromExists = from !== null && from !== undefined
	const toExists = to !== null && to !== undefined

	if (!fromExists && !toExists) {
		return null
	}

	const isRange = from !== to
	const visual = isRange ? `${fromExists ? toHoursAndMinutes(from) : ''} - ${toExists ? toHoursAndMinutes(to) : ''}` : toHoursAndMinutes(from || to)

	const accessibleDuration = isRange
		? formatMessage(
				{ id: 'Duration: {from} – {to}', defaultMessage: 'Duration: {from} – {to}' },
				{
					from: fromExists ? formatAccessibleDuration(from) : '',
					to: toExists ? formatAccessibleDuration(to) : ''
				}
			)
		: formatMessage({ id: 'Duration: {duration}', defaultMessage: 'Duration: {duration}' }, { duration: formatAccessibleDuration(from || to) })

	return (
		<>
			<span aria-hidden>{visual}</span>
			<VisuallyHidden>{accessibleDuration}</VisuallyHidden>
		</>
	)
}

export default RenderDuration
